import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class ManaInstruction extends Instruction<"mana"> {
  readonly type = "mana";

  act(context: ProgramModel) {
    context.mana += 1;
    context.flux += 1;
  }
}
